webpackJsonp([129],{

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/scss/document/error-code.scss
var error_code = __webpack_require__(170);
var error_code_default = /*#__PURE__*/__webpack_require__.n(error_code);

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__(2);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/js/libs/utils-suspension.js + 1 modules
var utils_suspension = __webpack_require__(5);

// EXTERNAL MODULE: ./src/js/config/prod.js
var prod = __webpack_require__(0);

// CONCATENATED MODULE: ./src/js/api/document.js
/**
 * 资料库相关的接口
 */


function document_getErrorCodeInfo(code, page) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/example/error_code',
      type: 'get',
      data: {
        code: code,
        page: page
      },
      dataType: 'json',
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}


// EXTERNAL MODULE: ./src/js/libs/utils.js
var utils = __webpack_require__(1);

// CONCATENATED MODULE: ./src/js/entry/document/error-code.js







$(function () {
  // 创建pageList是为了防止部分情况下scroll事件多次触发
  var pageList = [];
  // 根据链接code参数获取错误码信息,筛选非数字数据
  var code = Object(utils["c" /* getQueryString */])('code');
  if (code) {
    code = code.replace(/[^\d]/g, '');
  }
  if (code) {
    getErrorCodeInfo(code);
    $('#errorCode').val(code);
  } else {
    getAllErrorCodeInfo();
  }
  // 输入框策略，输入框为空显示全部数据，输入框为五位数据自动搜索
  $('#errorCode').on('input', function (e) {
    if ($('#errorCode').val() === '' && code !== '') {
      code = '';
      $('.icon-search').trigger('click');
    } else if ($('#errorCode').val().length === 5 && $('#errorCode').val() !== code) {
      code = $('#errorCode').val();
      $('.icon-search').trigger('click');
    }
  });
  $(document).keyup(function (event) {
    if (event.keyCode === 13 || event.keyCode === '13') {
      $('.icon-search').trigger('click');
    }
  });
  $('.icon-search').click(function () {
    code = $('#errorCode').val();
    pageList = [];
    changeUrl(code);
    if (code) {
      getErrorCodeInfo(code);
    } else {
      getAllErrorCodeInfo();
    }
  });
  Object(utils_suspension["a" /* suspension */])();
  // 获取所有错误码相关信息
  function getAllErrorCodeInfo(code, page) {
    page = page || 1;
    document_getErrorCodeInfo(code, page).then(function (result) {
      var codeInfo = '';
      var codeInfoList = [];
      var trList = '';
      if (result.code === 0 || result.code === '0') {
        pageList[page - 1] = true;
        codeInfo = result.data;
        codeInfoList = codeInfo.content;
        for (var i = 0; i < codeInfo.numberOfElements; i++) {
          trList += getTrList(codeInfoList[i]);
        }
        if (codeInfo.first) {
          $('.query-result-contain').empty().append(getThList());
        }
        $('#error-code-table-list').append(trList);
        if (!codeInfo.last && !pageList[page]) {
          page++;
          bindScrollLoad(page);
        }
      } else {
        $.alerts.alert('错误码信息获取失败： ' + result.desc);
      }
    });
  }

  // 获取某个错误码相关信息，和上面的代码分开写是因为接口返回数据格式不同
  function getErrorCodeInfo(code) {
    $(window).off('.myScroll');
    document_getErrorCodeInfo(code).then(function (result) {
      var codeInfo = '';
      var trList = '';
      if (result.code === 0 || result.code === '0') {
        codeInfo = result.data;
        if (codeInfo) {
          trList += getTrList(codeInfo);
          $('.query-result-contain').empty().append(getThList());
          $('#error-code-table-list').append(trList);
        } else {
          notFound();
        }
      } else {
        $.alerts.alert('错误码信息获取失败： ' + result.desc);
      }
    });
  }

  // 表格数据模板字面量
  function getTrList(item) {
    var trList = '';
    var trUrl = '';
    handleStr(item);
    item.solution = linkfilter(item.solution);
    if (item.reference && item.reference !== '无') {
      item.reference = linkfilter(item.reference);
      trUrl = '' + item.reference;
    } else {
      trUrl = '<div class="no-tr-url">无</div>';
    }
    trList += '<tr class="error-code-list">\n      <td>' + item.errorCode + '</td>\n      <td>' + item.explanation + '</td>\n      <td>' + item.errorCause + '</td>\n      <td>' + item.solution + '</td>\n      <td>' + trUrl + '</td>\n    </tr>';
    return trList;
  }

  // 表格头模板字面量
  function getThList() {
    return '<table height="76">\n    <thead>\n      <tr class="error-code-table-head">\n        <th>\u9519\u8BEF\u7801</th>\n        <th>\u9519\u8BEF\u7801\u89E3\u91CA</th>\n        <th>\u62A5\u9519\u539F\u56E0</th>\n        <th>\u89E3\u51B3\u65B9\u6848</th>\n        <th>\u8BBA\u575B\u53C2\u8003</th>\n      </tr>\n    </thead>\n    <tbody id="error-code-table-list"></tbody>\n  </table>';
  }

  // 未查询到数据模板字面量
  function notFound() {
    $(window).off('.myScroll');
    var tip = '<p class="not-found-tip">\u672A\u67E5\u8BE2\u5230 ' + $('#errorCode').val() + ' \u9519\u8BEF\u7801\u4FE1\u606F\uFF0C\u5982\u9047\u5230\u5176\u4ED6\u95EE\u9898\uFF0C\u53EF\u4EE5\u5728\u652F\u6301\u4E2D\u5FC3 <a class="bbs-link" href="' + prod["a" /* config */].CONSOLE + 'workorder/commit" target="_blank">\u63D0\u4EA4\u95EE\u9898</a> \u3002</p>';
    $('.query-result-contain').empty().append(tip);
  }

  // 绑定滚动事件
  function bindScrollLoad(page) {
    var $window = $(window);
    var $document = $(document);
    $window.on('scroll.myScroll', function () {
      var drop = 360;
      if ($document.scrollTop() + $window.height() + drop > $document.height() && !pageList[page - 1]) {
        pageList[page - 1] = true;
        getAllErrorCodeInfo('', page);
        $window.off('.myScroll');
      }
    });
  }

  // 提取文本中的链接
  function linkfilter(msg) {
    var url = msg;
    var urlRegExp = new RegExp('(https:|http:|doc.)[a-zA-Z0-9/?&=._]+');
    var newmsg = '';
    while (urlRegExp.exec(url) != null) {
      var pipeiurl = urlRegExp.exec(url);
      var newurl = '';
      // 为doc.开头的链接添加域名，避免href跳转错误
      if (pipeiurl[0].indexOf('doc.') > -1) {
        newurl = '<a class="bbs-link" href="https://' + pipeiurl[0] + '" target="_blank">' + pipeiurl[0] + '</a>';
      } else {
        newurl = '<a class="bbs-link" href="' + pipeiurl[0] + '" target="_blank">' + pipeiurl[0] + '</a>';
      }
      var urllength = pipeiurl[0].length;
      var start = url.indexOf(pipeiurl[0]);
      newmsg += url.substring(0, start) + newurl;
      url = url.substring(start + urllength);
    }
    msg = newmsg + url;
    return msg;
  }

  // 对\n\t\s字段处理，使文本在页面上按一定格式呈现，
  // 之所以将\s替换成‘ ’，而不是&npsb，是因为数据库返回的数据处理不当，前端使用&npsb会影响链接url的判断
  function handleStr(str) {
    for (var key in str) {
      if (typeof str[key] === 'string' && (str[key].indexOf('\n') > -1 || RegExp(/\s/).test(str[key]))) {
        str[key] = str[key].replace(/\r\n/g, '<br>').replace(/\n/g, '<br>').replace(/\s/g, ' ');
      }
    }
  }

  // 通过history.pushState实现无刷新修改url链接，不支持低版本浏览器
  function changeUrl(code) {
    if (window.history.pushState) {
      window.history.pushState(null, null, '?code=' + code);
    } else {
      window.open('/document/error-code?code=' + code, '_self');
    }
  }
});

/***/ }),

/***/ 170:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/js/api/user.js
var user = __webpack_require__(4);

// EXTERNAL MODULE: ./src/js/libs/utils-layer.js
var utils_layer = __webpack_require__(7);

// EXTERNAL MODULE: ./src/js/libs/utils-cookie.js
var utils_cookie = __webpack_require__(3);

// EXTERNAL MODULE: ./src/js/libs/utils.js
var utils = __webpack_require__(1);

// EXTERNAL MODULE: ./src/js/config/prod.js
var prod = __webpack_require__(0);

// EXTERNAL MODULE: ./src/scss/component/announcement.scss
var announcement = __webpack_require__(6);
var announcement_default = /*#__PURE__*/__webpack_require__.n(announcement);

// CONCATENATED MODULE: ./src/js/libs/utils-announcement.js
/**
 * 公告
 */


var _countDown = null;
var ancmtModel = {
  addEvent: function addEvent() {
    $('.ancmt-detail').on('click', '.ancmt-bullet-box-close-btn', function () {
      $('.ancmt-wrap').hide();
    });
    $('body').not('.ancmt-wrap').bind('click', function () {
      $('.ancmt-wrap').hide();
    });
  },
  countDown: function countDown() {
    var allTime = 15;
    _countDown = setInterval(function () {
      $('#abb_num').text(--allTime);
      if (allTime < 0) {
        $('.ancmt-wrap').hide();
        clearInterval(_countDown);
      }
    }, 1000);
  },
  fireAction: function fireAction() {
    $('#open_announcement').bind('click', function (e) {
      e.stopPropagation();
      $('.ancmt-wrap').show();
    });
  },
  showTop: function showTop() {
    if (!utils_cookie["a" /* cookie */].get('top_banner_closed')) {
      $('#top_banner_wrap').show();
    }
  },
  bindTopAction: function bindTopAction() {
    $('#close_banner_top').bind('click', function () {
      $('#top_banner_wrap').hide();
      var curDate = new Date();
      var curTamp = curDate.getTime();
      var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
      var passedTamp = curTamp - curWeeHours;
      var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
      var leftTime = new Date();
      leftTime.setTime(leftTamp + curTamp);
      utils_cookie["a" /* cookie */].pureSet('top_banner_closed', true, leftTime.toGMTString() + ';path=/');
    });
  },
  init: function init() {
    var that = this;
    that.addEvent();
    that.fireAction();
    that.showTop();
    that.bindTopAction();
    // that.countDown()
  }
};
ancmtModel.init();
// CONCATENATED MODULE: ./src/js/libs/utils-suspension.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return suspension; });
/**
 * Created by lycheng on 2017/11/29.
 * 悬浮的狗，返回顶部
 */







function initZcScript(w, d, e, x) {
  w[e] = function () {
    w.cbk = w.cbk || [];
    w.cbk.push(arguments);
  };
  x = d.createElement("script");
  x.async = true;
  x.id = "zhichiScript";
  x.className = "im-btn";
  x.src = "https://chat.sobot.com/chat/frame/v2/entrance.js?sysnum=1f851a5acb6e4f408a3e3e5487750951";
  d.body.appendChild(x);
}

function initZc(userInfo) {
  var nick = userInfo.nickname;
  var nickLogin = userInfo.login;
  var nickMiddle = nickLogin.length / 2;
  var isEven = nickLogin.length % 2 === 0;
  var nickEncry = isEven ? nickMiddle : Math.ceil(nickMiddle) - 2;
  nickLogin = nickLogin.length > 5 ? nickLogin.replace(nickLogin.substring(nickEncry, nickEncry + 2), "***") : nickLogin;
  user["a" /* aesEncry */](userInfo.uid).then(function (r) {
    var uid = r.data;
    var isZcBack = window.location.search.includes("isZc=1");
    initZcScript(window, document, "zc");
    var args = {
      customField7: uid
    };
    var prms = {
      uid: uid
    };
    zc("config", {
      uname: nick || nickLogin,
      custom: true, // 设置自定义
      color: "2277e6",
      customer_fields: JSON.stringify(args),
      params: JSON.stringify(prms),
      partnerid: uid,
      auto_expand: isZcBack
    });
    zc("dynamic_ready");
  });
}
/**
 * 右侧悬浮
 * @param s:距离顶部的高度
 */
function suspension(s, isIndex) {
  var $suspension = $('.suspension');
  if (!$suspension.length) {
    return;
  }
  var show400 = !(Object(utils["d" /* isWorkTime */])() && Object(utils["e" /* isWorkday */])());
  if (show400) {
    $('#feedback_btn').before('\n    <div class="suspension-item-wrap suspension-phone-wrap">\n      <i class="icons icons-suspension-phone"></i>\n      <div>\n        <div class="suspension-number-title">\u670D\u52A1\u70ED\u7EBF</div>\n        <p class="suspension-number-phone">4000-199-199</p>\n      </div>\n    </div>\n    ');
  }
  var $backTop = $('.suspension-back-top');
  var $susIcon = $('.sus-icon');
  var winH = $(window).height();
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop < s - winH / 2) {
      $suspension.css({
        position: 'absolute',
        top: s + 'px'
      });
    } else {
      $suspension.css({
        position: 'fixed',
        top: '50%'
      });
    }
    if (scrollTop > winH / 2) {
      $backTop.show();
    } else {
      $backTop.hide();
    }
  });
  $(window).scroll();
  $backTop.click(function () {
    $('body, html').animate({ 'scrollTop': 0 }, 500);
    return false;
  });

  function checkImLog() {
    user["d" /* getUserinfo */]().then(function (result) {
      if (result.code === 80000) {
        $(".im-icon").removeClass("im-btn");
        $(".im-icon").click(function () {
          var jumpBack = typeof window !== "undefined" ? Base64.encode(Object(utils["f" /* setQueryString */])("isZc", 1)) : "";
          window.location.href = prod["a" /* config */].PASSPORT + '/login?jump=' + jumpBack;
        });
      } else {
        initZc(result.data);
      }
    });
  }

  checkImLog();

  // $(".im-icon").click(function () {
  //   checkImLog()
  // });
}


/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[169]);


// WEBPACK FOOTER //
// js/document/error-code.c57248f5c5913d8bd96d.bundle.js